var _line, _line2, _path, _path2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionarePrinNivelDeLichid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 83,
    viewBox: "0 0 76 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 35.5,
    x2: 28,
    y2: 35.5,
    stroke: "black",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 31,
    y1: 35.5,
    x2: 40,
    y2: 35.5,
    stroke: "black",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 35.5C19.5 36.2849 18.8174 37.2792 17.0594 38.1368C15.3685 38.9616 12.9622 39.5 10.25 39.5C7.53775 39.5 5.13153 38.9616 3.44058 38.1368C1.68256 37.2792 1 36.2849 1 35.5C1 34.7151 1.68256 33.7208 3.44058 32.8632C5.13153 32.0384 7.53775 31.5 10.25 31.5C12.9622 31.5 15.3685 32.0384 17.0594 32.8632C18.8174 33.7208 19.5 34.7151 19.5 35.5Z",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 30.5L10 6.5",
    stroke: "black",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 43,
    y1: 35.5,
    x2: 52,
    y2: 35.5,
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionarePrinNivelDeLichid);
export default __webpack_public_path__ + "static/media/actionare_prin_nivel_de_lichid.c8b2d67afa462bed0b39f66215b0fa92.svg";
export { ForwardRef as ReactComponent };